// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".retake-overlay--dqL2Q{top:0;left:0;bottom:0;right:0;background:rgba(0,0,0,.7)}.foreground--eLufw{color:#fff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"retake-overlay": "retake-overlay--dqL2Q",
	"foreground": "foreground--eLufw"
};
export default ___CSS_LOADER_EXPORT___;
